const CtaSection = () => {
  return (
    <section className="bg-black pb-[64px] md:pb-[80px] lg:pb-[103px]">
      <div className="max-w-[1306px] mx-auto px-5 md:px-8 lg:px-0">
        <div className="rounded-[16px] border border-white/15 px-[24px] md:px-[40px] py-[48px] md:py-[64px] lg:py-[84px] text-center">
          <h2 className="text-white font-bold leading-[1.12] text-[26px] sm:text-[32px] md:text-[40px] lg:text-[52px]">
            Let's Launch Your Campaign
          </h2>
          <p className="mt-[16px] md:mt-[24px] text-white/60 text-[14px] md:text-[15px] lg:text-[17px]">
            Built for independent artists. Backed by real results.
          </p>
          <button
            onClick={() => (window.location.href = '/contact')}
            className="mt-[24px] md:mt-[34px] bg-[#FF8000] text-white text-[14px] md:text-[15px] font-normal py-[10px] px-[24px] rounded-[8px] hover:shadow-lg hover:shadow-orange-500/30 hover:scale-105 transition-all duration-300"
          >
            Start Your Campaign
          </button>
        </div>
      </div>
    </section>
  );
};

export default CtaSection;
